// extracted by mini-css-extract-plugin
module.exports = {"labelRow":"PunchupFieldLabel_labelRow__bZ2hr","help":"PunchupFieldLabel_help__xl3Kl"};